import { FormField, InlineButton } from "@prequel/shared-components";

type Tag = { key: string; value: string };

type TagsBuilderProps = {
  tags: Tag[];
  setTags: React.Dispatch<React.SetStateAction<Tag[]>>;
  errorMsg?: string;
};
const TagsBuilder = ({ tags, setTags, errorMsg }: TagsBuilderProps) => {
  const onKeyChange = (index: number, newKey: string) => {
    setTags((prev) => prev.map((tag, i) => (i === index ? { ...tag, key: newKey } : tag)));
  };

  const onValueChange = (index: number, newValue: string) => {
    setTags((prev) => prev.map((tag, i) => (i === index ? { ...tag, value: newValue } : tag)));
  };

  const removeTag = (index: number) => {
    setTags((prev) => prev.filter((_, i) => i !== index));
  };

  const addTag = () => {
    setTags((prev) => [...prev, { key: "", value: "" }]);
  };

  return (
    <div className="space-y-2">
      <h3 className="text-sm font-medium text-gray-700">Tags</h3>
      {tags.map((tag, index) => (
        <div key={index} className="mb-1.5 flex gap-2">
          <FormField
            id={`tag-key-${index}`}
            type="text"
            placeholder="Key"
            value={tag.key}
            onChangeHandler={(s) => onKeyChange(index, s)}
          />
          <FormField
            id={`tag-value-${index}`}
            type="text"
            placeholder="Value"
            value={tag.value}
            onChangeHandler={(s) => onValueChange(index, s)}
          />
          <InlineButton text="x" onClick={() => removeTag(index)} />
        </div>
      ))}
      {errorMsg && <p className="mt-1 text-xs font-medium text-red-600">{errorMsg}</p>}
      <InlineButton text="+ Add tag" onClick={addTag} />
    </div>
  );
};

export default TagsBuilder;
